import { Images, QuestionGroup, QuestionType, ScenarioStep, Steps } from '../state/interfaces'
import { emailAddress, provinces } from './common-steps'
import { currentProviderInternet } from './internet-steps'
import { currentProviderMobile } from './mobile-steps'

export const provincesEmailCollector: ScenarioStep = {
  ...provinces,
  next: Steps.EMAIL_ADDRESS_EMAIL_COLLECTOR,
}

export const emailAddressEmailCollector: ScenarioStep = {
  ...emailAddress,
  id: Steps.EMAIL_ADDRESS_EMAIL_COLLECTOR,
  next: Steps.CURRENT_PROVIDER_MOBILE_EMAIL_COLLECTOR,
}

export const currentProviderMobileEmailCollector: ScenarioStep = {
  ...currentProviderMobile,
  id: Steps.CURRENT_PROVIDER_MOBILE_EMAIL_COLLECTOR,
  next: Steps.CURRENT_PROVIDER_INTERNET_EMAIL_COLLECTOR,
}

export const currentProviderInternetEmailCollector: ScenarioStep = {
  ...currentProviderInternet,
  id: Steps.CURRENT_PROVIDER_INTERNET_EMAIL_COLLECTOR,
  next: Steps.THANKS_EMAIL_COLLECTOR,
}

export const thanksEmailCollector: ScenarioStep = {
  id: Steps.THANKS_EMAIL_COLLECTOR,
  group: QuestionGroup.DEFAULT,
  question: 'thanks-country_question',
  type: QuestionType.CHOICE_AS_MAIN_PILL,
  next: Steps.DONE,
  answers: [
    {
      id: 'close',
      text: 'common_close',
    },
  ],
  metadata: { grandImage: Images.REVIEW_11 },
}
